import React from "react";
import { Button, Icon } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export function FormFooterStart(_a) {
    var handleSubmit = _a.handleSubmit, onSubmit = _a.onSubmit, onInvalid = _a.onInvalid, buttonMessageId = _a.buttonMessageId, _b = _a.submitting, submitting = _b === void 0 ? false : _b;
    return (React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: submitting, onClick: handleSubmit(onSubmit, onInvalid) }, submitting ? (React.createElement(React.Fragment, null,
        React.createElement(Icon, { icon: "spinner-ellipsis", size: "small" }),
        React.createElement(FormattedMessage, { id: "ui-br-agency.button.saving" }))) : (React.createElement(FormattedMessage, { id: buttonMessageId }))));
}
